export class MultipleFilterModel {
    public multipleFilterId: string;
    public selectedFilters : string[];
}